<template>
  <div class="icon-picker-widget">
    <div class="icon-picker-widget-wrapper">
      <div>
        <div class="tabs">
          <div
            v-for="option in getIconPickerDisplayItems"
            class="tab-items"
            :class="{ active: selectedItem == option.key }"
            :key="option.key"
            @click="toggleTab(option.key)"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
      <div v-if="getLinkType == 'icon'">
        <!-- add filter icon option -->
        <!-- <div class="my-3">
          <input placeholder="Search" type="text" />
        </div> -->
        <div class="img-list mt-2">
          <div class="icon-picker-img-wrapper">
            <img
              v-for="icon in icons"
              :key="icon"
              :src="icon"
              @click="updateUrl(icon, 'icon')"
              alt=""
            />
          </div>
        </div>
      </div>
      <div v-else-if="getLinkType == 'illustration'">
        <div class="img-list mt-2">
          <div class="icon-picker-img-wrapper">
            <img
              v-for="illustration in illustrationsList"
              :key="illustration"
              :src="illustration"
              @click="updateUrl(illustration, 'illustration')"
              alt=""
            />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="my-3">
          <input
            v-if="isFieldIcon"
            placeholder="URL…"
            type="text"
            v-model="customInputUrl"
            @blur="updateUrl"
          />
          <input
            v-if="!isFieldIcon"
            placeholder="URL…"
            type="text"
            :value="getUrl"
            @blur="updateUrl"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { illustrations, icons } from '../../constants/images';
export default {
  name: 'IconPicker',
  data() {
    return {
      icons: icons,
      illustrationsList: illustrations,
      selectedItem:
        this.element && this.element.linkType
          ? this.element.linkType
          : 'custom',
      customInputUrl: '',
      iconPickerItems: [
        { label: 'Icons', key: 'icon' },
        { label: 'Galerie', key: 'illustration' },
        { label: 'Benutzerdefiniert', key: 'custom' },
      ],
    };
  },
  props: {
    displayIconPickerSections: {
      type: Array,
      required: true,
    },
    element: {
      type: Object,
      required: null,
    },
    isFieldIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    toggleTab(tab) {
      this.selectedItem = tab;
      this.$emit('onToggleTab', this.selectedItem);
    },
    updateUrl(e, type = 'custom') {
      if (this.iconLoading) return;
      if (this.element.linkType != this.selectedItem)
        this.$emit('updateLinkType', this.selectedItem);
      if (type == 'icon' || type == 'illustration') this.$emit('updateUrl', e);
      else this.$emit('updateUrl', e.target.value);
    },
    setSelectedItemCustom() {
      this.selectedItem = 'custom';
    },
  },

  computed: {
    getUrl() {
      if (this.element?.linkType === this.selectedItem) {
        return this.element.icon || this.element.url || this.element.img;
      } else return '';
    },
    getLinkType() {
      if (this.selectedItem || this.element || this.element.linkType)
        return this.selectedItem;
      return 'custom';
    },
    getIconPickerDisplayItems() {
      return this.iconPickerItems.filter((displayItem) =>
        this.displayIconPickerSections.includes(displayItem.key)
      );
    },
  },

  watch: {
    'element.name'() {
      if (this.isFieldIcon && this.element && this.element.icon)
        this.customInputUrl =
          this.element.icon == 'null' ? '' : this.element.icon;
      else this.customInputUrl = '';
    },
  },
};
</script>

<style scoped>
.icon-picker-widget {
  border-radius: 4px;
  background: white;
  position: absolute;
  z-index: 21;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.09);
}

.icon-picker-widget .icon-picker-widget-wrapper {
  width: 275px;
  overflow: hidden;
  padding: 10px;
}
.icon-picker-widget .icon-picker-widget-wrapper .tabs {
  display: flex;
  width: 100%;
  box-shadow: rgba(55, 53, 47, 0.09) 0px -1px 0px inset;
}
.icon-picker-widget .icon-picker-widget-wrapper .tabs .tab-items {
  transition: background 20ms ease-in 0s;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 28px;
  font-size: 14px;
  padding-left: 8px;
  padding-right: 8px;
  position: relative;
  color: #000;
}
.icon-picker-widget .icon-picker-widget-wrapper .tabs .tab-items:hover {
  background-color: #ededed;
}
.icon-picker-widget
  .icon-picker-widget-wrapper
  .tabs
  .tab-items.active::before {
  position: absolute;
  content: '';
  border-bottom: 2px solid #37352f;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.icon-picker-widget .icon-picker-widget-wrapper .img-list {
  height: 200px;
  overflow: auto;
}
.icon-picker-widget .icon-picker-widget-wrapper .img-list .icon-category {
  margin: 6px 0px 8px 5px;
  align-self: center;
  font-size: 11px;
  font-weight: 500;
  line-height: 120%;
  text-transform: uppercase;
}

.icon-picker-widget .icon-picker-widget-wrapper input {
  background: #fff;
  border-right: medium none;
  width: 100%;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}

.icon-picker-widget .icon-picker-widget-wrapper .icon-picker-img-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.icon-picker-widget .icon-picker-widget-wrapper .icon-picker-img-wrapper img {
  cursor: pointer;
  width: 52px;
  padding: 8px;
  margin: 5px;
  background: #ededed;
}
</style>
